import { createFileRoute } from "@tanstack/react-router";

import PlatformConsolePage from "@/features/dashboard/pages/platform-console";

export const Route = createFileRoute("/(app)/dashboard/platform")({
  component: PlatformConsolePage,
});
